<template>
  <div class="form__input form__input--checkbox"
       :class="{'form__input--error': data.error}">
    <input v-model="isChecked"
           v-bind:id="cssId"
           type="checkbox">
    <label v-bind:for="cssId"
           v-word="labelWord">
    </label>
    <a v-if="labelLink"
        :href="labelLink"
        target="_blank">
      <i class="icon-open"></i>
    </a>
    <p v-if="data.error"
       class="form__input__error">{{ data.error }}</p>
  </div>
</template>

<script>
import wordDirective from '../directives/word';
import formElement from '../mixins/form-element';

export default {
  mixins: [formElement],
  props: [
    'label',
    'data',
    'downloadLink',
    'labelWord',
    'wordingsEditable',
    'wordings',
    'wordingsMeta',
    'labelLink',
  ],
  directives: {
    word: wordDirective,
  },
  data() {
    return {
      cssId: '',
    };
  },
  computed: {
    isChecked: {
      get() {
        return this.data.val;
      },
      set(newVal) {
        this.$emit('change', !!newVal, this.data.valName);
      },
    },
  },
  created() {
    this.cssId = '' + this.data.valName + '__' + Math.random();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/InputCheckbox.vue